function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

const toggleHandler = (event) => {
    if (!event.target.hasAttribute('open')) {
        return;
    }

    const group = event.target.closest('.accordion-group');
    if (!group) {
        return;
    }

    const opened = group.querySelectorAll('details[open]');
    for (let accordion of opened) {
        if (accordion === event.target) {
            continue;
        }
        accordion.removeAttribute('open');
    }

    if (!isInViewport(event.target.querySelector('summary'))) {
        event.target.scrollIntoView({ behavior: "smooth" });
    }
};

document.addEventListener('toggle', toggleHandler, true);
